module.exports = __webpack_public_path__ + "static/cabina-de-control---tablero-de-control-f7d46c8dd1ea9b1c14f7d501c587086d.jpg";